export const WORKFLOW_MOBILE_MEDIA = '(max-width: 768px)';

export function workflowDialogClassName(baseClass, isSmallScreen) {
  const base = (baseClass || 'main-dialog').trim();
  return isSmallScreen ? `${base} workflow-dialog--mobile` : base;
}

export function workflowDialogShellProps(isSmallScreen) {
  return {
    fullScreen: Boolean(isSmallScreen),
    scroll: 'paper',
  };
}
